import { Injectable } from '@angular/core';
import { RoutePathBuilder } from '@ngspot/route-path-builder';

@Injectable()
export class RoutesForPicking extends RoutePathBuilder {
    queue() {
        return this.url('');
    }

    pick() {
        return this.url('perform');
    }

    willCall() {
        return this.urlFromCommands(['manage', 'will-call']);
    }

    hotShot() {
        return this.urlFromCommands(['manage', 'hot-shot']);
    }
}
